import { v4 as uuidv4 } from 'uuid';

import { portalApi } from '../../../api';
import { editCustomPolicyPropertiesStack } from '../../../components/RequirementTemplateBuilder/util/customPolicyFormStacks';
import dataTypes from '../../../constants/dataTypes';
import { fieldInputTypes } from '../../../constants/fieldInputTypes';
import { Statuses } from '../../../constants/statuses';
import companyKeys from '../../../services/models/company/keys';
import requirementTemplateKeys from '../../../services/models/requirementTemplates/keys';
import { modifyArrayItemAt, removeArrayItemAt, removeArrayItemAtIndex } from '../../../utils/arrayUtil';
import { debounceAction } from '../../../utils/debounce';
import { queryClient } from '../../../utils/queryClientUtil';
import { createErrorToast, createSuccessToast } from '../../modules/app';
import { selectCompanyId } from '../../modules/company';
/**
 * utility to build the search filters from the state
 */
export const withRequirementTemplateBlueprint = (name, stateOverrides = {}) => {
  const REQUIREMENT_TEMPLATES_SET_CURRENT_FOLDER = 'REQUIREMENT_TEMPLATES_SET_CURRENT_FOLDER';
  const REQUIREMENT_TEMPLATES_SET_TEMPLATE_STATUS_FILTERS = 'REQUIREMENT_TEMPLATES_SET_TEMPLATE_STATUS_FILTERS';
  const REQUIREMENT_TEMPLATES_SET_TEMPLATE_CREATOR_FILTER = 'REQUIREMENT_TEMPLATES_SET_TEMPLATE_CREATOR_FILTER';

  const REQUIREMENT_TEMPLATES_UPDATE_SEARCH_FILTER = 'REQUIREMENT_TEMPLATES_UPDATE_SEARCH_FILTER';
  const REQUIREMENT_TEMPLATES_SET_CURRENT_SORT = 'REQUIREMENT_TEMPLATES_SET_CURRENT_SORT';

  const REQUIREMENT_TEMPLATES_CREATE_FOLDER = 'REQUIREMENT_TEMPLATES_CREATE_FOLDER';
  const REQUIREMENT_TEMPLATES_CREATE_FOLDER_SUCCESS = 'REQUIREMENT_TEMPLATES_CREATE_FOLDER_SUCCESS';
  const REQUIREMENT_TEMPLATES_CREATE_FOLDER_FAILURE = 'REQUIREMENT_TEMPLATES_CREATE_FOLDER_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_FOLDERS = 'REQUIREMENT_TEMPLATES_LIST_FOLDERS';
  const REQUIREMENT_TEMPLATES_LIST_FOLDERS_SUCCESS = 'REQUIREMENT_TEMPLATES_LIST_FOLDERS_SUCCESS';
  const REQUIREMENT_TEMPLATES_LIST_FOLDERS_FAILURE = 'REQUIREMENT_TEMPLATES_LIST_FOLDERS_FAILURE';

  const REQUIREMENT_TEMPLATES_UPDATE_FOLDER = 'REQUIREMENT_TEMPLATES_UPDATE_FOLDER';
  const REQUIREMENT_TEMPLATES_UPDATE_FOLDER_SUCCESS = 'REQUIREMENT_TEMPLATES_UPDATE_FOLDER_SUCCESS';
  const REQUIREMENT_TEMPLATES_UPDATE_FOLDER_FAILURE = 'REQUIREMENT_TEMPLATES_UPDATE_FOLDER_FAILURE';

  const REQUIREMENT_TEMPLATES_DELETE_FOLDER = 'REQUIREMENT_TEMPLATES_DELETE_FOLDER';
  const REQUIREMENT_TEMPLATES_DELETE_FOLDER_SUCCESS = 'REQUIREMENT_TEMPLATES_DELETE_FOLDER_SUCCESS';
  const REQUIREMENT_TEMPLATES_DELETE_FOLDER_FAILURE = 'REQUIREMENT_TEMPLATES_DELETE_FOLDER_FAILURE';

  const REQUIREMENT_TEMPLATES_CREATE_TEMPLATE = 'REQUIREMENT_TEMPLATES_CREATE_TEMPLATE';
  const REQUIREMENT_TEMPLATES_CREATE_TEMPLATE_SUCCESS = 'REQUIREMENT_TEMPLATES_CREATE_TEMPLATE_SUCCESS';
  const REQUIREMENT_TEMPLATES_CREATE_TEMPLATE_FAILURE = 'REQUIREMENT_TEMPLATES_CREATE_TEMPLATE_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_TEMPLATES = 'REQUIREMENT_TEMPLATES_LIST_TEMPLATES';
  const REQUIREMENT_TEMPLATES_LIST_TEMPLATES_SUCCESS = 'REQUIREMENT_TEMPLATES_LIST_TEMPLATES_SUCCESS';
  const REQUIREMENT_TEMPLATES_LIST_TEMPLATES_FAILURE = 'REQUIREMENT_TEMPLATES_LIST_TEMPLATES_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_FOLDER_TEMPLATES = 'REQUIREMENT_TEMPLATES_LIST_FOLDER_TEMPLATES';
  const REQUIREMENT_TEMPLATES_LIST_ARCHIVED_TEMPLATES = 'REQUIREMENT_TEMPLATES_LIST_ARCHIVED_TEMPLATES';
  const REQUIREMENT_TEMPLATES_LIST_DRAFTED_TEMPLATES = 'REQUIREMENT_TEMPLATES_LIST_DRAFTED_TEMPLATES';

  const REQUIREMENT_TEMPLATES_GET_TEMPLATE = 'REQUIREMENT_TEMPLATES_GET_TEMPLATE';
  const REQUIREMENT_TEMPLATES_GET_TEMPLATE_SUCCESS = 'REQUIREMENT_TEMPLATES_GET_TEMPLATE_SUCCESS';
  const REQUIREMENT_TEMPLATES_GET_TEMPLATE_FAILURE = 'REQUIREMENT_TEMPLATES_GET_TEMPLATE_FAILURE';

  const REQUIREMENT_TEMPLATES_UPDATE_TEMPLATE = 'REQUIREMENT_TEMPLATES_UPDATE_TEMPLATE';
  const REQUIREMENT_TEMPLATES_UPDATE_TEMPLATE_SUCCESS = 'REQUIREMENT_TEMPLATES_UPDATE_TEMPLATE_SUCCESS';
  const REQUIREMENT_TEMPLATES_UPDATE_TEMPLATE_FAILURE = 'REQUIREMENT_TEMPLATES_UPDATE_TEMPLATE_FAILURE';

  const REQUIREMENT_TEMPLATES_DELETE_TEMPLATE = 'REQUIREMENT_TEMPLATES_DELETE_TEMPLATE';
  const REQUIREMENT_TEMPLATES_DELETE_TEMPLATE_SUCCESS = 'REQUIREMENT_TEMPLATES_DELETE_TEMPLATE_SUCCESS';
  const REQUIREMENT_TEMPLATES_DELETE_TEMPLATE_FAILURE = 'REQUIREMENT_TEMPLATES_DELETE_TEMPLATE_FAILURE';

  const REQUIREMENT_TEMPLATES_CREATE_BLOCK = 'REQUIREMENT_TEMPLATES_CREATE_BLOCK';
  const REQUIREMENT_TEMPLATES_CREATE_BLOCK_SUCCESS = 'REQUIREMENT_TEMPLATES_CREATE_BLOCK_SUCCESS';
  const REQUIREMENT_TEMPLATES_CREATE_BLOCK_FAILURE = 'REQUIREMENT_TEMPLATES_CREATE_BLOCK_FAILURE';

  const REQUIREMENT_TEMPLATES_UPDATE_BLOCK = 'REQUIREMENT_TEMPLATES_UPDATE_BLOCK';
  const REQUIREMENT_TEMPLATES_UPDATE_BLOCK_SUCCESS = 'REQUIREMENT_TEMPLATES_UPDATE_BLOCK_SUCCESS';
  const REQUIREMENT_TEMPLATES_UPDATE_BLOCK_FAILURE = 'REQUIREMENT_TEMPLATES_UPDATE_BLOCK_FAILURE';

  const REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_POLICY_TYPE = 'REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_POLICY_TYPE';
  const REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_POLICY_TYPE_SUCCESS = 'REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_POLICY_TYPE_SUCCESS';
  const REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_POLICY_TYPE_FAILURE = 'REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_POLICY_TYPE_FAILURE';

  const REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_DOCUMENT_TYPE = 'REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_DOCUMENT_TYPE';
  const REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_DOCUMENT_TYPE_SUCCESS = 'REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_DOCUMENT_TYPE_SUCCESS';
  const REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_DOCUMENT_TYPE_FAILURE = 'REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_DOCUMENT_TYPE_FAILURE';

  const REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_LANGUAGE = 'REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_LANGUAGE';
  const REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_LANGUAGE_SUCCESS = 'REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_LANGUAGE_SUCCESS';
  const REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_LANGUAGE_FAILURE = 'REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_LANGUAGE_FAILURE';

  const REQUIREMENT_TEMPLATES_DELETE_BLOCK = 'REQUIREMENT_TEMPLATES_DELETE_BLOCK';
  const REQUIREMENT_TEMPLATES_DELETE_BLOCK_SUCCESS = 'REQUIREMENT_TEMPLATES_DELETE_BLOCK_SUCCESS';
  const REQUIREMENT_TEMPLATES_DELETE_BLOCK_FAILURE = 'REQUIREMENT_TEMPLATES_DELETE_BLOCK_FAILURE';

  const REQUIREMENT_TEMPLATES_SET_POLICY_TYPE_FILTERS = 'REQUIREMENT_TEMPLATES_SET_POLICY_TYPE_FILTERS';
  const REQUIREMENT_TEMPLATES_UPDATE_POLICY_TYPE_SEARCH_FILTER = 'REQUIREMENT_TEMPLATES_UPDATE_POLICY_TYPE_SEARCH_FILTER';

  const REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE = 'REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE';
  const REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE_SUCCESS = 'REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE_SUCCESS';
  const REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE_FAILURE = 'REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_POLICY_TYPES = 'REQUIREMENT_TEMPLATES_LIST_POLICY_TYPES';
  const REQUIREMENT_TEMPLATES_LIST_POLICY_TYPES_SUCCESS = 'REQUIREMENT_TEMPLATES_LIST_POLICY_TYPES_SUCCESS';
  const REQUIREMENT_TEMPLATES_LIST_POLICY_TYPES_FAILURE = 'REQUIREMENT_TEMPLATES_LIST_POLICY_TYPES_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_DEFAULT_POLICY_TYPES = 'REQUIREMENT_TEMPLATES_LIST_DEFAULT_POLICY_TYPES';
  const REQUIREMENT_TEMPLATES_LIST_CUSTOM_POLICY_TYPES = 'REQUIREMENT_TEMPLATES_LIST_CUSTOM_POLICY_TYPES';

  const REQUIREMENT_TEMPLATES_DELETE_POLICY_TYPE = 'REQUIREMENT_TEMPLATES_DELETE_POLICY_TYPE';
  const REQUIREMENT_TEMPLATES_DELETE_POLICY_TYPE_SUCCESS = 'REQUIREMENT_TEMPLATES_DELETE_POLICY_TYPE_SUCCESS';
  const REQUIREMENT_TEMPLATES_DELETE_POLICY_TYPE_FAILURE = 'REQUIREMENT_TEMPLATES_DELETE_POLICY_TYPE_FAILURE';

  const REQUIREMENT_TEMPLATES_SET_DOCUMENT_TYPE_FILTERS = 'REQUIREMENT_TEMPLATES_SET_DOCUMENT_TYPE_FILTERS';
  const REQUIREMENT_TEMPLATES_UPDATE_DOCUMENT_TYPE_SEARCH_FILTER = 'REQUIREMENT_TEMPLATES_UPDATE_DOCUMENT_TYPE_SEARCH_FILTER';

  const REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE = 'REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE';
  const REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE_SUCCESS = 'REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE_SUCCESS';
  const REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE_FAILURE = 'REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_DOCUMENT_TYPES = 'REQUIREMENT_TEMPLATES_LIST_DOCUMENT_TYPES';
  const REQUIREMENT_TEMPLATES_LIST_DOCUMENT_TYPES_SUCCESS = 'REQUIREMENT_TEMPLATES_LIST_DOCUMENT_TYPES_SUCCESS';
  const REQUIREMENT_TEMPLATES_LIST_DOCUMENT_TYPES_FAILURE = 'REQUIREMENT_TEMPLATES_LIST_DOCUMENT_TYPES_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_DELETED_DOCUMENT_TYPES = 'REQUIREMENT_TEMPLATES_LIST_DELETED_DOCUMENT_TYPES';
  const REQUIREMENT_TEMPLATES_LIST_DELETED_DOCUMENT_TYPES_SUCCESS = 'REQUIREMENT_TEMPLATES_LIST_DELETED_DOCUMENT_TYPES_SUCCESS';
  const REQUIREMENT_TEMPLATES_LIST_DELETED_DOCUMENT_TYPES_FAILURE = 'REQUIREMENT_TEMPLATES_LIST_DELETED_DOCUMENT_TYPES_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_DEFAULT_DOCUMENT_TYPES = 'REQUIREMENT_TEMPLATES_LIST_DEFAULT_DOCUMENT_TYPES';
  const REQUIREMENT_TEMPLATES_LIST_CUSTOM_DOCUMENT_TYPES = 'REQUIREMENT_TEMPLATES_LIST_CUSTOM_DOCUMENT_TYPES';

  const REQUIREMENT_TEMPLATES_DELETE_DOCUMENT_TYPE = 'REQUIREMENT_TEMPLATES_DELETE_DOCUMENT_TYPE';
  const REQUIREMENT_TEMPLATES_DELETE_DOCUMENT_TYPE_SUCCESS = 'REQUIREMENT_TEMPLATES_DELETE_DOCUMENT_TYPE_SUCCESS';
  const REQUIREMENT_TEMPLATES_DELETE_DOCUMENT_TYPE_FAILURE = 'REQUIREMENT_TEMPLATES_DELETE_DOCUMENT_TYPE_FAILURE';

  const REQUIREMENT_TEMPLATES_SET_LANGUAGE_FILTERS = 'REQUIREMENT_TEMPLATES_SET_LANGUAGE_FILTERS';
  const REQUIREMENT_TEMPLATES_UPDATE_LANGUAGE_SEARCH_FILTER = 'REQUIREMENT_TEMPLATES_UPDATE_LANGUAGE_SEARCH_FILTER';

  const REQUIREMENT_TEMPLATES_CREATE_LANGUAGE = 'REQUIREMENT_TEMPLATES_CREATE_LANGUAGE';
  const REQUIREMENT_TEMPLATES_CREATE_LANGUAGE_SUCCESS = 'REQUIREMENT_TEMPLATES_CREATE_LANGUAGE_SUCCESS';
  const REQUIREMENT_TEMPLATES_CREATE_LANGUAGE_FAILURE = 'REQUIREMENT_TEMPLATES_CREATE_LANGUAGE_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_LANGUAGES = 'REQUIREMENT_TEMPLATES_LIST_LANGUAGES';
  const REQUIREMENT_TEMPLATES_LIST_LANGUAGES_SUCCESS = 'REQUIREMENT_TEMPLATES_LIST_LANGUAGES_SUCCESS';
  const REQUIREMENT_TEMPLATES_LIST_LANGUAGES_FAILURE = 'REQUIREMENT_TEMPLATES_LIST_LANGUAGES_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_DEFAULT_LANGUAGES = 'REQUIREMENT_TEMPLATES_LIST_DEFAULT_LANGUAGES';
  const REQUIREMENT_TEMPLATES_LIST_CUSTOM_LANGUAGES = 'REQUIREMENT_TEMPLATES_LIST_CUSTOM_LANGUAGES';

  const REQUIREMENT_TEMPLATES_LIST_DELETED_LANGUAGES = 'REQUIREMENT_TEMPLATES_LIST_DELETED_LANGUAGES';
  const REQUIREMENT_TEMPLATES_LIST_DELETED_LANGUAGES_SUCCESS = 'REQUIREMENT_TEMPLATES_LIST_DELETED_LANGUAGES_SUCCESS';
  const REQUIREMENT_TEMPLATES_LIST_DELETED_LANGUAGES_FAILURE = 'REQUIREMENT_TEMPLATES_LIST_DELETED_LANGUAGES_FAILURE';

  const REQUIREMENT_TEMPLATES_DELETE_LANGUAGE = 'REQUIREMENT_TEMPLATES_DELETE_LANGUAGE';
  const REQUIREMENT_TEMPLATES_DELETE_LANGUAGE_SUCCESS = 'REQUIREMENT_TEMPLATES_DELETE_LANGUAGE_SUCCESS';
  const REQUIREMENT_TEMPLATES_DELETE_LANGUAGE_FAILURE = 'REQUIREMENT_TEMPLATES_DELETE_LANGUAGE_FAILURE';

  const REQUIREMENT_TEMPLATES_ADD_POLICY_TYPE_FAVORITE = 'REQUIREMENT_TEMPLATES_ADD_POLICY_TYPE_FAVORITE';
  const REQUIREMENT_TEMPLATES_ADD_POLICY_TYPE_FAVORITE_SUCCESS = 'REQUIREMENT_TEMPLATES_ADD_POLICY_TYPE_FAVORITE_SUCCESS';
  const REQUIREMENT_TEMPLATES_ADD_POLICY_TYPE_FAVORITE_FAILURE = 'REQUIREMENT_TEMPLATES_ADD_POLICY_TYPE_FAVORITE_FAILURE';

  const REQUIREMENT_TEMPLATES_REMOVE_POLICY_TYPE_FAVORITE = 'REQUIREMENT_TEMPLATES_REMOVE_POLICY_TYPE_FAVORITE';
  const REQUIREMENT_TEMPLATES_REMOVE_POLICY_TYPE_FAVORITE_SUCCESS = 'REQUIREMENT_TEMPLATES_REMOVE_POLICY_TYPE_FAVORITE_SUCCESS';
  const REQUIREMENT_TEMPLATES_REMOVE_POLICY_TYPE_FAVORITE_FAILURE = 'REQUIREMENT_TEMPLATES_REMOVE_POLICY_TYPE_FAVORITE_FAILURE';

  const REQUIREMENT_TEMPLATES_ADD_DOCUMENT_TYPE_FAVORITE = 'REQUIREMENT_TEMPLATES_ADD_DOCUMENT_TYPE_FAVORITE';
  const REQUIREMENT_TEMPLATES_ADD_DOCUMENT_TYPE_FAVORITE_SUCCESS = 'REQUIREMENT_TEMPLATES_ADD_DOCUMENT_TYPE_FAVORITE_SUCCESS';
  const REQUIREMENT_TEMPLATES_ADD_DOCUMENT_TYPE_FAVORITE_FAILURE = 'REQUIREMENT_TEMPLATES_ADD_DOCUMENT_TYPE_FAVORITE_FAILURE';

  const REQUIREMENT_TEMPLATES_REMOVE_DOCUMENT_TYPE_FAVORITE = 'REQUIREMENT_TEMPLATES_REMOVE_DOCUMENT_TYPE_FAVORITE';
  const REQUIREMENT_TEMPLATES_REMOVE_DOCUMENT_TYPE_FAVORITE_SUCCESS = 'REQUIREMENT_TEMPLATES_REMOVE_DOCUMENT_TYPE_FAVORITE_SUCCESS';
  const REQUIREMENT_TEMPLATES_REMOVE_DOCUMENT_TYPE_FAVORITE_FAILURE = 'REQUIREMENT_TEMPLATES_REMOVE_DOCUMENT_TYPE_FAVORITE_FAILURE';

  const REQUIREMENT_TEMPLATES_ADD_LANGUAGE_FAVORITE = 'REQUIREMENT_TEMPLATES_ADD_LANGUAGE_FAVORITE';
  const REQUIREMENT_TEMPLATES_ADD_LANGUAGE_FAVORITE_SUCCESS = 'REQUIREMENT_TEMPLATES_ADD_LANGUAGE_FAVORITE_SUCCESS';
  const REQUIREMENT_TEMPLATES_ADD_LANGUAGE_FAVORITE_FAILURE = 'REQUIREMENT_TEMPLATES_ADD_LANGUAGE_FAVORITE_FAILURE';

  const REQUIREMENT_TEMPLATES_REMOVE_LANGUAGE_FAVORITE = 'REQUIREMENT_TEMPLATES_REMOVE_LANGUAGE_FAVORITE';
  const REQUIREMENT_TEMPLATES_REMOVE_LANGUAGE_FAVORITE_SUCCESS = 'REQUIREMENT_TEMPLATES_REMOVE_LANGUAGE_FAVORITE_SUCCESS';
  const REQUIREMENT_TEMPLATES_REMOVE_LANGUAGE_FAVORITE_FAILURE = 'REQUIREMENT_TEMPLATES_REMOVE_LANGUAGE_FAVORITE_FAILURE';

  const REQUIREMENT_TEMPLATES_SET_CREATE_CUSTOM_STEP = 'REQUIREMENT_TEMPLATES_SET_CREATE_CUSTOM_STEP';
  const REQUIREMENT_TEMPLATES_SET_CURRENT_POLICY_PROPERTY_FIELD_TYPE = 'REQUIREMENT_TEMPLATES_SET_CURRENT_POLICY_PROPERTY_FIELD_TYPE';

  const REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_POLICY_ID = 'REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_POLICY_ID';
  const REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_DOCUMENT_ID = 'REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_DOCUMENT_ID';
  const REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_LANGUAGE_ID = 'REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_LANGUAGE_ID';

  const REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_POLICY_TYPE = 'REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_POLICY_TYPE';
  const REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_DOCUMENT_TYPE = 'REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_DOCUMENT_TYPE';
  const REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_LANGUAGE = 'REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_LANGUAGE';

  const REQUIREMENT_TEMPLATES_UPDATE_CURRENT_POLICY_INPUT_OPTIONS = 'REQUIREMENT_TEMPLATES_UPDATE_CURRENT_POLICY_INPUT_OPTIONS';
  const REQUIREMENT_TEMPLATES_DELETE_CURRENT_POLICY_INPUT_OPTION = 'REQUIREMENT_TEMPLATES_DELETE_CURRENT_POLICY_INPUT_OPTION';
  const REQUIREMENT_TEMPLATES_RESET_SELECTED_TEMPLATE = 'REQUIREMENT_TEMPLATES_RESET_SELECTED_TEMPLATE';

  const REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES = 'REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES';
  const REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES_SUCCESS = 'REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES_SUCCESS';
  const REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES_FAILURE = 'REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES_FAILURE';

  const REQUIREMENT_TEMPLATES_UPDATE_PUBLISHED_LIST_SORT = 'REQUIREMENT_TEMPLATES_UPDATE_PUBLISHED_LIST_SORT';
  const REQUIREMENT_TEMPLATES_SET_PUBLISHED_CREATOR_FILTER = 'REQUIREMENT_TEMPLATES_SET_PUBLISHED_CREATOR_FILTER';
  const REQUIREMENT_TEMPLATES_UPDATE_PUBLISHED_SEARCH_FILTER = 'REQUIREMENT_TEMPLATES_UPDATE_PUBLISHED_SEARCH_FILTER';
  const REQUIREMENT_TEMPLATES_SET_CURRENT_TEMPLATE_BLOCK = 'REQUIREMENT_TEMPLATES_SET_CURRENT_TEMPLATE_BLOCK';
  const REQUIREMENT_TEMPLATES_SET_CURRENT_EDIT_TEMPLATE = 'REQUIREMENT_TEMPLATES_SET_CURRENT_EDIT_TEMPLATE';
  const REQUIREMENT_TEMPLATES_RESET_CURRENT_TEMPLATE_BLOCK = 'REQUIREMENT_TEMPLATES_RESET_CURRENT_TEMPLATE_BLOCK';

  const REQUIREMENT_TEMPLATES_SETUP_EDIT_CUSTOM_POLICY = 'REQUIREMENT_TEMPLATES_SETUP_EDIT_CUSTOM_POLICY';
  const REQUIREMENT_TEMPLATES_SETUP_EDIT_CUSTOM_POLICY_SUCCESS = 'REQUIREMENT_TEMPLATES_SETUP_EDIT_CUSTOM_POLICY_SUCCESS';
  const REQUIREMENT_TEMPLATES_SETUP_EDIT_CUSTOM_POLICY_FAILURE = 'REQUIREMENT_TEMPLATES_SETUP_EDIT_CUSTOM_POLICY_FAILURE';

  const REQUIREMENT_TEMPLATES_RESET_FILTERS = 'REQUIREMENT_TEMPLATES_RESET_FILTERS';

  const REQUIREMENT_TEMPLATES_SET_STAGED_FOLDER = 'REQUIREMENT_TEMPLATES_SET_STAGED_FOLDER';
  const REQUIREMENT_TEMPLATES_SET_CURRENT_INSURED_ID = 'REQUIREMENT_TEMPLATES_SET_CURRENT_INSURED_ID';
  const REQUIREMENT_TEMPLATES_SET_CURRENT_JOB_ID = 'REQUIREMENT_TEMPLATES_SET_CURRENT_JOB_ID';

  const REQUIREMENT_TEMPLATES_BULK_CREATE_TEMPLATE_BLOCKS = 'REQUIREMENT_TEMPLATES_BULK_CREATE_TEMPLATE_BLOCKS';
  const REQUIREMENT_TEMPLATES_BULK_CREATE_TEMPLATE_BLOCKS_SUCCESS = 'REQUIREMENT_TEMPLATES_BULK_CREATE_TEMPLATE_BLOCKS_SUCCESS';
  const REQUIREMENT_TEMPLATES_BULK_CREATE_TEMPLATE_BLOCKS_FAILURE = 'REQUIREMENT_TEMPLATES_BULK_CREATE_TEMPLATE_BLOCKS_FAILURE';

  const REQUIREMENT_TEMPLATES_SET_BACK_BUTTON_TEXT = 'REQUIREMENT_TEMPLATES_SET_BACK_BUTTON_TEXT';

  const REQUIREMENT_TEMPLATES_BULK_DELETE_AND_CREATE_REQUIREMENT_TEMPLATE_BLOCKS = 'REQUIREMENT_TEMPLATES_BULK_DELETE_AND_CREATE_REQUIREMENT_TEMPLATE_BLOCKS';
  const REQUIREMENT_TEMPLATES_BULK_DELETE_AND_CREATE_REQUIREMENT_TEMPLATE_BLOCKS_SUCCESS = 'REQUIREMENT_TEMPLATES_BULK_DELETE_AND_CREATE_REQUIREMENT_TEMPLATE_BLOCKS_SUCCESS';
  const REQUIREMENT_TEMPLATES_BULK_DELETE_AND_CREATE_REQUIREMENT_TEMPLATE_BLOCKS_FAILURE = 'REQUIREMENT_TEMPLATES_BULK_DELETE_AND_CREATE_REQUIREMENT_TEMPLATE_BLOCKS_FAILURE';

  const REQUIREMENT_TEMPLATES_LIST_DELETED_POLICY_TYPES = 'REQUIREMENT_TEMPLATES_LIST_DELETED_POLICY_TYPES';
  const REQUIREMENT_TEMPLATES_LIST_DELETED_POLICY_TYPES_SUCCESS = 'REQUIREMENT_TEMPLATES_LIST_DELETED_POLICY_TYPES_SUCCESS';
  const REQUIREMENT_TEMPLATES_LIST_DELETED_POLICY_TYPES_FAILURE = 'REQUIREMENT_TEMPLATES_LIST_DELETED_POLICY_TYPES_FAILURE';

  const REQUIREMENT_TEMPLATES_SET_UPDATING_REQUIREMENTS = 'REQUIREMENT_TEMPLATES_SET_UPDATING_REQUIREMENTS';
  const REQUIREMENT_TEMPLATES_RESET_ALL = 'REQUIREMENT_TEMPLATES_RESET_ALL';

  const REQUIREMENT_TEMPLATES_SET_DROPDOWN_TEMPLATE_ID = 'REQUIREMENT_TEMPLATES_SET_DROPDOWN_TEMPLATE_ID';
  const REQUIREMENT_TEMPLATES_RESET_DROPDOWN_TEMPLATE_ID = 'REQUIREMENT_TEMPLATES_RESET_DROPDOWN_TEMPLATE_ID';

  const REQUIREMENT_TEMPLATES_UPDATE_OR_CREATE_INSURED_REQUIREMENT_TEMPLATE = 'REQUIREMENT_TEMPLATES_UPDATE_OR_CREATE_INSURED_REQUIREMENT_TEMPLATE';
  const REQUIREMENT_TEMPLATES_UPDATE_OR_CREATE_INSURED_REQUIREMENT_TEMPLATE_SUCCESS = 'REQUIREMENT_TEMPLATES_UPDATE_OR_CREATE_INSURED_REQUIREMENT_TEMPLATE_SUCCESS';
  const REQUIREMENT_TEMPLATES_UPDATE_OR_CREATE_INSURED_REQUIREMENT_TEMPLATE_FAILURE = 'REQUIREMENT_TEMPLATES_UPDATE_OR_CREATE_INSURED_REQUIREMENT_TEMPLATE_FAILURE';

  const REQUIREMENT_TEMPLATES_RESET_CURRENT_FOLDER = 'REQUIREMENT_TEMPLATES_RESET_CURRENT_FOLDER';

  const REQUIREMENT_TEMPLATES_SET_PUBLISHING_STATUS = 'REQUIREMENT_TEMPLATES_SET_PUBLISHING_STATUS';

  const REQUIREMENT_TEMPLATES_SET_CURRENT_POLICY_TYPE = 'REQUIREMENT_TEMPLATES_SET_CURRENT_POLICY_TYPE';
  const REQUIREMENT_TEMPLATES_RESET_CURRENT_POLICY_TYPE = 'REQUIREMENT_TEMPLATES_RESET_CURRENT_POLICY_TYPE';

  const REQUIREMENT_TEMPLATES_DELETE_EMPTY_BLOCKS = 'REQUIREMENT_TEMPLATES_DELETE_EMPTY_BLOCKS';
  const REQUIREMENT_TEMPLATES_DELETE_EMPTY_BLOCKS_SUCCESS = 'REQUIREMENT_TEMPLATES_DELETE_EMPTY_BLOCKS_SUCCESS';
  const REQUIREMENT_TEMPLATES_DELETE_EMPTY_BLOCKS_FAILURE = 'REQUIREMENT_TEMPLATES_DELETE_EMPTY_BLOCKS_FAILURE';

  const REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT = 'REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT';
  const REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT_SUCCESS = 'REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT_SUCCESS';
  const REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT_FAILURE = 'REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT_FAILURE';

  const REQUIREMENT_TEMPLATES_UPDATE_QUESTION = 'REQUIREMENT_TEMPLATES_UPDATE_QUESTION';

  const REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT = 'REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT';
  const REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_SUCCESS = 'REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_SUCCESS';
  const REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_FAILURE = 'REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_FAILURE';

  const REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK = 'REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK';
  const REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK_SUCCESS = 'REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK_SUCCESS';
  const REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK_FAILURE = 'REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK_FAILURE';

  const initialState = {
    blueprintName: name,
    showSideHeaders: true,
    builderHeight: '100%',
    sidePanelHeight: '94%',
    backButtonOptions: {
      executable: () => {},
      buttonText: '',
      url: ''
    },
    saveButtonOptions: {
      text: '',
      type: ''
    },
    leftTabTypeOption: '',
    rightTabTypeOption: '',
    folders: {
      currentFolder: null,
      data: []
    },
    templates: {
      sort: 'name',
      templateStatusFilter: { published: true },
      creatorsFilter: [],
      searchFilter: '',
      folderFilter: '',
      data: []
    },
    allPublishedTemplates: {
      data: [],
      sort: 'name',
      creatorsFilter: [],
      searchFilter: '',
      isLoading: true
    },
    templatesLoading: true,
    selectedTemplate: null,
    changesPublishedStatus: Statuses.General,
    policyTypes: {
      data: [],
      filters: {
        customs: true,
        defaults: true
      },
      searchTerm: '',
      deletedData: [],
      currentPolicyType: null
    },
    documentTypes: {
      data: [],
      filters: {
        customs: true,
        defaults: true
      },
      searchTerm: '',
      deletedData: []
    },
    languages: {
      data: [],
      filters: {
        customs: true,
        defaults: true
      },
      searchTerm: '',
      deletedData: []
    },
    displayOptions: {
      defaultTemplateTabIdLeft: 'requirement-templates',
      defaultTemplateTabIdRight: 'document-templates',
      currentPolicyPropertyFieldOptions: {},
      selectedPolicyPropertyFieldTypes: [],
      currentRequirementTemplateBlockId: null,
      editCustomPolicyId: null,
      editCustomDocumentId: null,
      editCustomLanguageId: null,
      currentEditTemplateId: null,
      updatingRequirements: false
    },
    dropDownTemplateId: null,
    ...stateOverrides
  };

  /* Actions
  ========================================================= */
  const setCurrentRequirementTemplateFolder = folderId => async dispatch => {
    if (!folderId) return;
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_CURRENT_FOLDER, folderId });
  };

  const setCurrentRequirementTemplateStatusFilters = templateStatusFilter => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_TEMPLATE_STATUS_FILTERS, templateStatusFilter });
  };

  const setCurrentRequirementTemplateCreatorFilter = creatorIds => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_TEMPLATE_CREATOR_FILTER, creatorIds });
    dispatch(listRequirementTemplates());
  };

  const setCurrentRequirementTemplateSearchFilter = searchTerm => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_SEARCH_FILTER, searchTerm });
    dispatch(listRequirementTemplates());
  };

  const setCurrentRequirementTemplateSort = sort => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_CURRENT_SORT, sort });
    dispatch(listRequirementTemplates());
  };

  const setDropdownTemplateId = templateId => dispatch => {
    if (typeof templateId !== 'number') {
      throw new Error('Error in setDropdownTemplateId: templateId must be a number');
    }

    dispatch({ name, templateId, type: REQUIREMENT_TEMPLATES_SET_DROPDOWN_TEMPLATE_ID });
  };

  const resetDropdownTemplateId = () => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_RESET_DROPDOWN_TEMPLATE_ID });
  };

  const createRequirementTemplateFolder = data => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_FOLDER, data });

    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.createRequirementTemplateFolder(companyId, data);

      await dispatch(listRequirementTemplateFolders());
      dispatch(listFolderRequirementTemplates(response.id));

      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_FOLDER_SUCCESS, response });

      queryClient.removeQueries(requirementTemplateKeys.companyFolders(companyId));

      return response;
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_FOLDER_FAILURE, error });
    }
  };

  const listRequirementTemplateFolders = (
    pageData = { pageNumber: 1, pageSize: 25 }
  ) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_FOLDERS, pageData });

    const companyId = selectCompanyId(getState());

    try {
      const { data, ...pageInfo } = await portalApi.listRequirementTemplateFolders(companyId, pageData);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_FOLDERS_SUCCESS, data, pageInfo });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_FOLDERS_FAILURE, error });
    }
  };

  const updateRequirementTemplateFolder = (folderId, data) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_FOLDER, folderId, data });

    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.updateRequirementTemplateFolder(folderId, data);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_FOLDER_SUCCESS, response });

      queryClient.removeQueries(requirementTemplateKeys.companyFolders(companyId));
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_FOLDER_FAILURE, error });
    }
  };

  const deleteRequirementTemplateFolder = folderId => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_FOLDER, folderId });

    const companyId = selectCompanyId(getState());

    try {
      await portalApi.deleteRequirementTemplateFolder(folderId);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_FOLDER_SUCCESS });
      queryClient.removeQueries(requirementTemplateKeys.companyFolders(companyId));
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_FOLDER_FAILURE, error });
    }
  };

  const createRequirementTemplate = data => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_TEMPLATE, data });

    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.createRequirementTemplate(companyId, data);
      await dispatch(listFolderRequirementTemplates(response.requirement_template_folder_id));
      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_TEMPLATE_SUCCESS, response });

      queryClient.removeQueries(requirementTemplateKeys.companyFolders(companyId));
      return response;
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_TEMPLATE_FAILURE, error });
      return { error };
    }
  };

  const listRequirementTemplates = debounceAction((pageData = { pageNumber: 1, pageSize: 25 }) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_TEMPLATES, pageData });

    const companyId = selectCompanyId(getState());
    const {
      templateStatusFilter,
      folderFilter,
      sort,
      creatorsFilter,
      searchFilter
    } = selectRequirementTemplates(getState());

    const filters = {
      ...templateStatusFilter,
      requirement_template_folder_id: folderFilter,
      creator_id: creatorsFilter.map(({ userId }) => userId),
      name: searchFilter
    };

    try {
      const { data, ...pageInfo } = await portalApi.listRequirementTemplates(
        companyId,
        pageData,
        filters,
        sort
      );

      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_TEMPLATES_SUCCESS, data, pageInfo });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_TEMPLATES_FAILURE, error });
    }
  });

  const listFolderRequirementTemplates = (folderId, pageData = { pageNumber: 1, pageSize: 25 }) => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_FOLDER_TEMPLATES, folderId });

    await dispatch(setCurrentRequirementTemplateStatusFilters({ published: true }));
    await dispatch(setCurrentRequirementTemplateFolder(folderId));

    dispatch(listRequirementTemplates(pageData));
  };

  const listArchivedRequirementTemplates = (pageData = { pageNumber: 1, pageSize: 25 }) => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_ARCHIVED_TEMPLATES, pageData });

    await dispatch(setCurrentRequirementTemplateStatusFilters({ archived: true }));
    await dispatch(resetCurrentFolder());

    dispatch(listRequirementTemplates(pageData));
  };

  const listDraftedRequirementTemplates = (pageData = { pageNumber: 1, pageSize: 25 }) => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DRAFTED_TEMPLATES, pageData });

    await dispatch(setCurrentRequirementTemplateStatusFilters({ drafts: true }));
    await dispatch(resetCurrentFolder());

    dispatch(listRequirementTemplates(pageData));
  };

  const getRequirementTemplate = templateId => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_GET_TEMPLATE });

    try {
      const response = await portalApi.getRequirementTemplate(templateId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_GET_TEMPLATE_SUCCESS, response });
      return response;
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_GET_TEMPLATE_FAILURE, error });
    }
  };

  const updateRequirementTemplate = (templateId, data) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_TEMPLATE });
    dispatch(updateChangesPublishedStatus(Statuses.Updating));

    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.updateRequirementTemplate(templateId, data);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_TEMPLATE_SUCCESS, response });
      dispatch(updateChangesPublishedStatus(Statuses.Success));

      queryClient.removeQueries(requirementTemplateKeys.companyFolders(companyId));
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_TEMPLATE_FAILURE, error });
      dispatch(updateChangesPublishedStatus(Statuses.Error));
    }
  };

  const deleteRequirementTemplate = templateId => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_TEMPLATE, templateId });

    const companyId = selectCompanyId(getState());

    try {
      await portalApi.deleteRequirementTemplate(templateId);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_TEMPLATE_SUCCESS });

      queryClient.removeQueries(requirementTemplateKeys.companyFolders(companyId));
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_TEMPLATE_FAILURE, error });

      dispatch(listRequirementTemplates());
    }
  };

  const createRequirementTemplateBlock = data => async (dispatch, getState) => {
    const uuid = uuidv4();
    dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_BLOCK, data, tempId: uuid });

    try {
      const { id: templateId } = selectCurrentRequirementTemplate(getState());
      const response = await portalApi.createRequirementTemplateBlock(templateId, data);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_BLOCK_SUCCESS, response, tempId: uuid });
      return response;
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_BLOCK_FAILURE, error });
      const { id: templateId } = selectCurrentRequirementTemplate(getState());
      dispatch(getRequirementTemplate(templateId));
    }
  };

  const bulkCreateRequirementTemplateBlocks = blocks => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_BULK_CREATE_TEMPLATE_BLOCKS, blocks });

    const { id: templateId } = selectCurrentRequirementTemplate(getState());

    try {
      const promises = blocks.map(block => portalApi.createRequirementTemplateBlock(templateId, block));
      const response = await Promise.all(promises);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_BULK_CREATE_TEMPLATE_BLOCKS_SUCCESS, response });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_BULK_CREATE_TEMPLATE_BLOCKS_FAILURE, error });
    }
  };

  const updateRequirementTemplateBlock = (templateBlockId, data) => async (dispatch, getState) => {
    const { id: templateId, requirementTemplateBlocks, publishedAt } = selectCurrentRequirementTemplate(getState());

    const currentOrder = requirementTemplateBlocks.find(block => block.id === parseInt(templateBlockId, 10)).order;

    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_BLOCK, data, templateBlockId, currentOrder });

    if (publishedAt) dispatch(updateChangesPublishedStatus(Statuses.Updating));

    try {
      const response = await portalApi.updateRequirementTemplateBlock(templateBlockId, data);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_BLOCK_SUCCESS, response });
      if (publishedAt) dispatch(updateChangesPublishedStatus(Statuses.Success));
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_BLOCK_FAILURE, error });
      if (publishedAt) dispatch(updateChangesPublishedStatus(Statuses.Error));

      dispatch(getRequirementTemplate(templateId));
    }
  };

  const updateInsurancePolicyType = (policyTypeId, data) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_POLICY_TYPE, data, policyTypeId });
    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.updateInsurancePolicyType(companyId, policyTypeId, data);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_POLICY_TYPE_SUCCESS, response });
      dispatch(listInsurancePolicyTypes());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_POLICY_TYPE_FAILURE, error });
      dispatch(listInsurancePolicyTypes());
    }
  };

  const updateInsuranceDocumentType = (documentTypeId, data) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_DOCUMENT_TYPE, data, documentTypeId });
    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.updateInsuranceDocumentType(companyId, documentTypeId, data);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_DOCUMENT_TYPE_SUCCESS, response });
      dispatch(listInsuranceDocumentTypes());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_DOCUMENT_TYPE_FAILURE, error });
      dispatch(listInsuranceDocumentTypes());
    }
  };

  const updateInsuranceLanguage = (languageId, data) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_LANGUAGE, data, languageId });
    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.updateInsuranceLanguage(companyId, languageId, data);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_LANGUAGE_SUCCESS, response });
      dispatch(listInsuranceLanguages());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_INSURANCE_LANGUAGE_FAILURE, error });
      dispatch(listInsuranceLanguages());
    }
  };

  const deleteRequirementTemplateBlock = templateBlockId => async (dispatch, getState) => {
    const { id: templateId, requirementTemplateBlocks, publishedAt, companyId } = selectCurrentRequirementTemplate(getState());

    if (publishedAt) {
      dispatch(updateChangesPublishedStatus(Statuses.Updating));
    }

    const { order } = requirementTemplateBlocks.find(block => block.id === parseInt(templateBlockId, 10));
    dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_BLOCK, templateBlockId, order });

    try {
      await portalApi.deleteRequirementTemplateBlock(templateBlockId);
      await queryClient.invalidateQueries(companyKeys.companyQuestionCategoryBase(companyId));

      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_BLOCK_SUCCESS });
      dispatch(updateChangesPublishedStatus(Statuses.Success));
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_BLOCK_FAILURE, error });

      dispatch(getRequirementTemplate(templateId));
      dispatch(updateChangesPublishedStatus(Statuses.Error));
    }
  };

  const bulkDeleteAndCreateRequirementTemplateBlocks = createTemplateBlocks => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_BULK_DELETE_AND_CREATE_REQUIREMENT_TEMPLATE_BLOCKS });

    try {
      const currentTemplate = selectCurrentRequirementTemplate(getState());

      // Sequential delete to prevent locks
      for (let i = 0; i < currentTemplate.requirementTemplateBlocks.length; i += 1) {
        const block = currentTemplate.requirementTemplateBlocks[i];
        // eslint-disable-next-line no-await-in-loop
        await portalApi.deleteRequirementTemplateBlock(block.id);
      }

      const response = [];
      for (let j = 0; j < createTemplateBlocks.length; j += 1) {
        const block = createTemplateBlocks[j];
        // eslint-disable-next-line no-await-in-loop
        const resp = await portalApi.createRequirementTemplateBlock(currentTemplate.id, block);
        response.push(resp);
      }

      dispatch({
        name,
        type: REQUIREMENT_TEMPLATES_BULK_DELETE_AND_CREATE_REQUIREMENT_TEMPLATE_BLOCKS_SUCCESS,
        response
      });
    } catch (error) {
      dispatch({
        name,
        type: REQUIREMENT_TEMPLATES_BULK_DELETE_AND_CREATE_REQUIREMENT_TEMPLATE_BLOCKS_FAILURE,
        error
      });
    }
  };

  const setInsurancePolicyTypeFilters = filters => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_POLICY_TYPE_FILTERS, filters });
    dispatch(listInsurancePolicyTypes());
  };

  const updateInsurancePolicyTypeSearchFilter = debounceAction(searchTerm => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_POLICY_TYPE_SEARCH_FILTER, searchTerm });
    dispatch(listInsurancePolicyTypes());
  });

  const createInsurancePolicyType = data => async (dispatch, getState) => {
    const uuid = uuidv4();
    dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE, data, tempId: uuid });

    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.createInsurancePolicyType(companyId, data);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE_SUCCESS, response, tempId: uuid });

      await queryClient.invalidateQueries(companyKeys.companyAllPolicyTypes(companyId));

      return response;
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE_FAILURE, error });
      dispatch(listInsurancePolicyTypes());
      dispatch(createErrorToast({
        title: 'Uh oh, something went wrong',
        description: `Custom policy type was not created. \n ${error.message}`,
        error
      }));
    }
  };

  const listInsurancePolicyTypes = (pageData = { pageNumber: 1, pageSize: 25 }) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_POLICY_TYPES, pageData });

    const companyId = selectCompanyId(getState());
    const { filters: policyFilters, searchTerm } = selectInsurancePolicyTypes(getState());

    const filters = getFilters(policyFilters);

    const allFilters = { ...filters, display_name: searchTerm };

    try {
      const { data, ...pageInfo } = await portalApi.listInsurancePolicyTypes(companyId, pageData, allFilters);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_POLICY_TYPES_SUCCESS, data, pageInfo });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_POLICY_TYPES_FAILURE, error });
    }
  };

  const listDefaultInsurancePolicyTypes = () => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DEFAULT_POLICY_TYPES });

    await dispatch(setInsurancePolicyTypeFilters({ defaults: true }));
    dispatch(listInsurancePolicyTypes());
  };

  const listCustomInsurancePolicyTypes = () => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_CUSTOM_POLICY_TYPES });

    await dispatch(setInsurancePolicyTypeFilters({ customs: true }));
    dispatch(listInsurancePolicyTypes());
  };

  const deleteInsurancePolicyType = policyTypeId => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_POLICY_TYPE, policyTypeId });

    const companyId = selectCompanyId(getState());

    try {
      await portalApi.deleteInsurancePolicyType(companyId, policyTypeId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_POLICY_TYPE_SUCCESS });
      dispatch(listInsurancePolicyTypes());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_POLICY_TYPE_FAILURE, error });
      dispatch(listInsurancePolicyTypes());
    }
  };

  const listDeletedPolicyTypes = (pageData = { pageNumber: 1, pageSize: 100 }) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DELETED_POLICY_TYPES });

    const companyId = selectCompanyId(getState());

    try {
      const { data, ...pageInfo } = await portalApi
        .listInsurancePolicyTypes(companyId, pageData, { deleted_only: true });

      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DELETED_POLICY_TYPES_SUCCESS, data, pageInfo });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DELETED_POLICY_TYPES_FAILURE, error });
    }
  };

  const setInsuranceDocumentTypeFilters = filters => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_DOCUMENT_TYPE_FILTERS, filters });
    dispatch(listInsuranceDocumentTypes());
  };

  const updateInsuranceDocumentTypeSearchFilter = debounceAction(searchTerm => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_DOCUMENT_TYPE_SEARCH_FILTER, searchTerm });
    dispatch(listInsuranceDocumentTypes());
  });

  const createInsuranceDocumentType = data => async (dispatch, getState) => {
    const uuid = uuidv4();
    dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE, data, tempId: uuid });

    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.createInsuranceDocumentType(companyId, data);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE_SUCCESS, response, tempId: uuid });
      return response;
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE_FAILURE, error });
      dispatch(listInsuranceDocumentTypes());
    }
  };

  const listInsuranceDocumentTypes = (pageData = { pageNumber: 1, pageSize: 25 }) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DOCUMENT_TYPES, pageData });

    const companyId = selectCompanyId(getState());
    const { filters: documentFilters, searchTerm } = selectInsuranceDocumentTypes(getState());

    const filters = getFilters(documentFilters);

    const allFilters = { ...filters, display_name: searchTerm };

    try {
      const { data, ...pageInfo } = await portalApi.listInsuranceDocumentTypes(companyId, pageData, allFilters);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DOCUMENT_TYPES_SUCCESS, data, pageInfo });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DOCUMENT_TYPES_FAILURE, error });
    }
  };

  const listDeletedDocumentTypes = (pageData = { pageNumber: 1, pageSize: 100 }) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DELETED_DOCUMENT_TYPES });

    const companyId = selectCompanyId(getState());

    try {
      const { data, ...pageInfo } = await portalApi
        .listInsuranceDocumentTypes(companyId, pageData, { deleted: true });

      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DELETED_DOCUMENT_TYPES_SUCCESS, data, pageInfo });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DELETED_DOCUMENT_TYPES_FAILURE, error });
    }
  };

  const listDefaultInsuranceDocumentTypes = () => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DEFAULT_DOCUMENT_TYPES });

    await dispatch(setInsuranceDocumentTypeFilters({ defaults: true }));
    dispatch(listInsuranceDocumentTypes());
  };

  const listCustomInsuranceDocumentTypes = () => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_CUSTOM_DOCUMENT_TYPES });

    await dispatch(setInsuranceDocumentTypeFilters({ customs: true }));
    dispatch(listInsuranceDocumentTypes());
  };

  const deleteInsuranceDocumentType = documentTypeId => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_DOCUMENT_TYPE, documentTypeId });

    const companyId = selectCompanyId(getState());

    try {
      await portalApi.deleteInsuranceDocumentType(companyId, documentTypeId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_DOCUMENT_TYPE_SUCCESS });
      dispatch(listInsuranceDocumentTypes());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_DOCUMENT_TYPE_FAILURE, error });
      dispatch(listInsuranceDocumentTypes());
    }
  };

  const setInsuranceLanguageFilters = filters => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_LANGUAGE_FILTERS, filters });
    dispatch(listInsuranceLanguages());
  };

  const updateInsuranceLanguageSearchFilter = debounceAction(searchTerm => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_LANGUAGE_SEARCH_FILTER, searchTerm });
    dispatch(listInsuranceLanguages());
  });

  const createInsuranceLanguage = data => async (dispatch, getState) => {
    const uuid = uuidv4();
    dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_LANGUAGE, data, tempId: uuid });

    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.createInsuranceLanguage(companyId, data);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_LANGUAGE_SUCCESS, response, tempId: uuid });
      return response;
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_LANGUAGE_FAILURE, error });
      dispatch(listInsuranceLanguages());
    }
  };

  const listInsuranceLanguages = (pageData = { pageNumber: 1, pageSize: 25 }) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_LANGUAGES, pageData });

    const companyId = selectCompanyId(getState());
    const { filters: languageFilters, searchTerm } = selectInsuranceLanguages(getState());

    const filters = getFilters(languageFilters);
    const allFilters = { ...filters, display_name: searchTerm };

    try {
      const { data, ...pageInfo } = await portalApi.listInsuranceLanguages(companyId, pageData, allFilters);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_LANGUAGES_SUCCESS, data, pageInfo });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_LANGUAGES_FAILURE, error });
    }
  };

  const listDefaultInsuranceLanguages = () => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DEFAULT_LANGUAGES });

    await dispatch(setInsuranceLanguageFilters({ defaults: true }));
    dispatch(listInsuranceLanguages());
  };

  const listCustomInsuranceLanguages = () => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_CUSTOM_LANGUAGES });

    await dispatch(setInsuranceLanguageFilters({ customs: true }));
    dispatch(listInsuranceLanguages());
  };

  const listDeletedInsuranceLanguages = (pageData = { pageNumber: 1, pageSize: 100 }) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DELETED_LANGUAGES });

    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.listInsuranceLanguages(companyId, pageData, { deleted: true });
      const { data, ...pageInfo } = response;

      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DELETED_LANGUAGES_SUCCESS, data, pageInfo });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_DELETED_LANGUAGES_FAILURE, error });
    }
  };

  const deleteInsuranceLanguage = languageId => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_LANGUAGE, languageId });

    const companyId = selectCompanyId(getState());

    try {
      await portalApi.deleteInsuranceLanguage(companyId, languageId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_LANGUAGE_SUCCESS });
      dispatch(listInsuranceLanguages());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_LANGUAGE_FAILURE, error });
      dispatch(listInsuranceLanguages());
    }
  };

  const addPolicyTypeFavorite = policyTypeId => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_ADD_POLICY_TYPE_FAVORITE, policyTypeId });

    try {
      const response = await portalApi.addPolicyTypeFavorite(policyTypeId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_ADD_POLICY_TYPE_FAVORITE_SUCCESS, response });
      dispatch(listInsurancePolicyTypes());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_ADD_POLICY_TYPE_FAVORITE_FAILURE, error });
      dispatch(listInsurancePolicyTypes());
    }
  };

  const removePolicyTypeFavorite = policyTypeId => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_REMOVE_POLICY_TYPE_FAVORITE, policyTypeId });

    try {
      const response = await portalApi.removePolicyTypeFavorite(policyTypeId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_REMOVE_POLICY_TYPE_FAVORITE_SUCCESS, response });

      dispatch(listInsurancePolicyTypes());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_REMOVE_POLICY_TYPE_FAVORITE_FAILURE, error });
      dispatch(listInsurancePolicyTypes());
    }
  };

  const addDocumentTypeFavorite = documentTypeId => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_ADD_DOCUMENT_TYPE_FAVORITE, documentTypeId });

    try {
      const response = await portalApi.addDocumentTypeFavorite(documentTypeId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_ADD_DOCUMENT_TYPE_FAVORITE_SUCCESS, response });
      dispatch(listInsuranceDocumentTypes());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_ADD_DOCUMENT_TYPE_FAVORITE_FAILURE, error });
      dispatch(listInsuranceDocumentTypes());
    }
  };

  const removeDocumentTypeFavorite = documentTypeId => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_REMOVE_DOCUMENT_TYPE_FAVORITE, documentTypeId });

    try {
      const response = await portalApi.removeDocumentTypeFavorite(documentTypeId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_REMOVE_DOCUMENT_TYPE_FAVORITE_SUCCESS, response });

      dispatch(listInsuranceDocumentTypes());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_REMOVE_DOCUMENT_TYPE_FAVORITE_FAILURE, error });
      dispatch(listInsuranceDocumentTypes());
    }
  };

  const addLanguageFavorite = languageId => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_ADD_LANGUAGE_FAVORITE, languageId });

    try {
      const response = await portalApi.addLanguageFavorite(languageId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_ADD_LANGUAGE_FAVORITE_SUCCESS, response });
      dispatch(listInsuranceLanguages());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_ADD_LANGUAGE_FAVORITE_FAILURE, error });
      dispatch(listInsuranceLanguages());
    }
  };

  const removeLanguageFavorite = languageId => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_REMOVE_LANGUAGE_FAVORITE, languageId });

    try {
      const response = await portalApi.removeLanguageFavorite(languageId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_REMOVE_LANGUAGE_FAVORITE_SUCCESS, response });

      dispatch(listInsuranceLanguages());
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_REMOVE_LANGUAGE_FAVORITE_FAILURE, error });
      dispatch(listInsuranceLanguages());
    }
  };

  const setCreateCustomStep = (step, insuranceType) => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_CREATE_CUSTOM_STEP, step, insuranceType });
  };

  const setCurrentPolicyPropertyFieldType = propertyField => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_CURRENT_POLICY_PROPERTY_FIELD_TYPE, propertyField });
  };

  const setEditCustomPolicyId = customPolicyId => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_POLICY_ID, customPolicyId });
  };

  const setEditCustomDocumentId = customDocumentId => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_DOCUMENT_ID, customDocumentId });
  };

  const setEditCustomLanguageId = customLanguageId => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_LANGUAGE_ID, customLanguageId });
  };

  const resetCreateCustomPolicyType = () => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_POLICY_TYPE });
  };

  const resetCreateCustomDocumentType = () => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_DOCUMENT_TYPE });
  };

  const resetCreateCustomLanguage = () => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_LANGUAGE });
  };

  const updateCurrentPropertyInputOptions = (fieldType, options) => async (dispatch, getState) => {
    options.companyId = selectCompanyId(getState());
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_CURRENT_POLICY_INPUT_OPTIONS, fieldType, options });
  };

  const deleteCurrentPropertyInputOption = (fieldType, optionIndex) => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_CURRENT_POLICY_INPUT_OPTION, fieldType, optionIndex });
  };

  const resetSelectedTemplate = () => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_RESET_SELECTED_TEMPLATE });
  };

  const listAllPublishedTemplates = debounceAction((pageData = { pageNumber: 1, pageSize: 25 }) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES });

    const companyId = selectCompanyId(getState());
    const {
      sort,
      creatorsFilter,
      searchFilter
    } = selectPublishedRequirementTemplates(getState());

    const filters = {
      published: true,
      creator_id: creatorsFilter.map(({ userId }) => userId),
      name: searchFilter
    };

    try {
      const {
        data,
        ...pageInfo
      } = await portalApi.listRequirementTemplates(companyId, pageData, filters, sort);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES_SUCCESS, data, pageInfo });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES_FAILURE, error });
    }
  });

  const updatePublishedListSort = sort => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_PUBLISHED_LIST_SORT, sort });
    dispatch(listAllPublishedTemplates());
  };

  const setPublishedTemplatesCreatorFilter = creatorIds => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_PUBLISHED_CREATOR_FILTER, creatorIds });
    dispatch(listAllPublishedTemplates());
  };

  const updatePublishedTemplateSearchFilter = searchTerm => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_PUBLISHED_SEARCH_FILTER, searchTerm });
    dispatch(listAllPublishedTemplates());
  };

  const setCurrentRequirementTemplateBlock = blockId => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_CURRENT_TEMPLATE_BLOCK, blockId });
  };

  const setCurrentEditTemplateId = templateId => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_CURRENT_EDIT_TEMPLATE, templateId });
  };

  const resetCurrentRequirementTemplateBlock = () => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_RESET_CURRENT_TEMPLATE_BLOCK });
  };

  const setupEditCustomPolicyType = currentCustomPolicyTypeId => (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SETUP_EDIT_CUSTOM_POLICY, currentCustomPolicyTypeId });

    try {
      const currentCustomPolicy = selectInsurancePolicyTypes(getState()).data
        .filter(policyType => policyType.id === parseInt(currentCustomPolicyTypeId, 10));

      const properties = currentCustomPolicy?.[0]?.properties;

      const booleanProperties = properties
        ?.filter(property => property.dataType === dataTypes.Boolean);
      const monetaryProperties = properties
        ?.filter(property => property.dataType === dataTypes.Monetary);
      const alphanumericProperties = properties
        ?.filter(property => property.dataType === dataTypes.String);

      const fieldProperties = {};
      let fieldTypes = [];

      if (booleanProperties?.length > 0) {
        fieldTypes = [...fieldTypes, fieldInputTypes.Checkboxes];
        fieldProperties[fieldInputTypes.Checkboxes] = booleanProperties
          .map(() => editCustomPolicyPropertiesStack[fieldInputTypes.Checkboxes]);
      }

      if (monetaryProperties?.length > 0) {
        fieldTypes = [...fieldTypes, fieldInputTypes.Monetary];
        fieldProperties[dataTypes.Monetary] = monetaryProperties
          .map(() => editCustomPolicyPropertiesStack[fieldInputTypes.Monetary]);
      }

      if (alphanumericProperties?.length > 0) {
        fieldTypes = [...fieldTypes, fieldInputTypes.AlphaNumeric];
        fieldProperties[fieldInputTypes.AlphaNumeric] = alphanumericProperties
          .map(() => editCustomPolicyPropertiesStack[fieldInputTypes.AlphaNumeric]);
      }

      dispatch({ name, type: REQUIREMENT_TEMPLATES_SETUP_EDIT_CUSTOM_POLICY_SUCCESS, fieldProperties, fieldTypes });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_SETUP_EDIT_CUSTOM_POLICY_FAILURE, error });
    }
  };

  const resetFilters = requirementType => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_RESET_FILTERS, requirementType });
  };

  const setStagedFolder = folder => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_STAGED_FOLDER, folder });
  };

  const setCurrentInsuredId = insuredId => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_CURRENT_INSURED_ID, insuredId });
  };

  const setCurrentJobId = jobId => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_CURRENT_JOB_ID, jobId });
  };

  const setBackButtonText = text => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_BACK_BUTTON_TEXT, text });
  };

  const setUpdatingRequirements = updating => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_UPDATING_REQUIREMENTS, isUpdating: updating });
  };

  const resetRequirementTemplateState = () => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_RESET_ALL });
  };

  const updateOrCreateInsuredRequirementTemplate = requirementId => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_OR_CREATE_INSURED_REQUIREMENT_TEMPLATE });
    const companyId = selectCompanyId(getState());

    try {
      const response = await portalApi.updateOrCreateInsuredRequirementsTemplate(requirementId, companyId);

      dispatch({
        name,
        type: REQUIREMENT_TEMPLATES_UPDATE_OR_CREATE_INSURED_REQUIREMENT_TEMPLATE_SUCCESS,
        response
      });
    } catch (error) {
      dispatch({
        name,
        type: REQUIREMENT_TEMPLATES_UPDATE_OR_CREATE_INSURED_REQUIREMENT_TEMPLATE_FAILURE,
        error
      });
    }
  };

  const updateChangesPublishedStatus = status => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_PUBLISHING_STATUS, status });
  };

  const resetCurrentFolder = () => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_RESET_CURRENT_FOLDER });
  };

  const setCurrentPolicyType = policyType => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_SET_CURRENT_POLICY_TYPE, policyType });
  };

  const resetCurrentPolicyType = () => dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_RESET_CURRENT_POLICY_TYPE });
  };

  const deleteEmptyBlocks = () => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_EMPTY_BLOCKS });

    const requirementTemplateBlocks = selectCurrentRequirementTemplateBlocks(getState());
    const emptyBlocks = requirementTemplateBlocks.filter(b => !b.requirementTemplateBlockProperties || !b.requirementTemplateBlockProperties.length);
    try {
      const blockPromises = emptyBlocks?.map(block => dispatch(deleteRequirementTemplateBlock(block.id)));

      await Promise.all(blockPromises);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_EMPTY_BLOCKS_SUCCESS });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_EMPTY_BLOCKS_FAILURE, error: error.message });
    }
  };

  const createQuestionRequirement = (question, blockIds) => async (dispatch, getState) => {
    const uuid = uuidv4();
    dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT, question, blockIds, tempId: uuid });

    const requirementTemplate = selectCurrentRequirementTemplate(getState());
    const { id: templateId, requirementTemplateBlocks, companyId } = requirementTemplate;

    try {
      const response = await portalApi.createRequirementTemplateQuestion(templateId, question.id, blockIds);

      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT_SUCCESS, response, question, blockIds, tempId: uuid });

      dispatch(createSuccessToast({ title: 'Linked question to requirements', duration: 3000 }));

      queryClient.invalidateQueries(companyKeys.companyQuestionCategoryBase(companyId));
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT_FAILURE, error: error.message, previousState: requirementTemplateBlocks });

      dispatch(createErrorToast({ title: 'Something went wrong linking the question to requirements.', error }));
    }
  };

  const updateQuestion = (oldQuestionId, question) => async dispatch => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_UPDATE_QUESTION, oldQuestionId, question });
  };

  const deleteQuestionRequirement = questionId => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT, questionId });

    const requirementTemplate = selectCurrentRequirementTemplate(getState());
    const { id: templateId, requirementTemplateBlocks, companyId } = requirementTemplate;

    try {
      await portalApi.deleteRequirementTemplateQuestion(templateId, questionId);
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_SUCCESS, questionId });

      dispatch(createSuccessToast({ title: 'Removed question from requirements', duration: 3000 }));

      queryClient.invalidateQueries(companyKeys.companyQuestionCategoryBase(companyId));
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_FAILURE, error: error.message, previousState: requirementTemplateBlocks });

      dispatch(createErrorToast({ title: 'Something went wrong removing the question from requirements.', error }));
    }
  };

  const deleteQuestionRequirementBlock = (requirementTemplateQuestionId, templateBlockId) => async (dispatch, getState) => {
    dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK, requirementTemplateQuestionId, templateBlockId });

    const requirementTemplate = selectCurrentRequirementTemplate(getState());
    const { requirementTemplateBlocks, companyId } = requirementTemplate;

    try {
      await portalApi.deleteRequirementTemplateQuestionBlock(requirementTemplateQuestionId, templateBlockId);

      dispatch(createSuccessToast({ title: 'Removed question link', duration: 3000 }));

      queryClient.invalidateQueries(companyKeys.companyQuestionCategoryBase(companyId));
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK_SUCCESS, requirementTemplateQuestionId, templateBlockId });
    } catch (error) {
      dispatch({ name, type: REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK_FAILURE, error: error.message, previousState: requirementTemplateBlocks });

      dispatch(createErrorToast({ title: 'Something went wrong removing the question link.', error }));
    }
  };

  /* Reducer
  ========================================================= */
  const requirementTemplateReducer = (state = initialState, action) => {
    // This is where the magic happens. It allows us to use the same action types
    // across multiple similar reducers. All actions need a name attached to them.
    if (action.name !== name) return state;

    switch (action.type) {
      case REQUIREMENT_TEMPLATES_SET_CURRENT_FOLDER:
        return {
          ...state,
          folders: {
            ...state.folders,
            currentFolder: action.folderId
          },
          templates: {
            ...state.templates,
            folderFilter: action.folderId
          }
        };

      case REQUIREMENT_TEMPLATES_SET_DROPDOWN_TEMPLATE_ID:
        return {
          ...state,
          dropDownTemplateId: action.templateId
        };

      case REQUIREMENT_TEMPLATES_RESET_DROPDOWN_TEMPLATE_ID:
        return {
          ...state,
          dropDownTemplateId: null
        };

      case REQUIREMENT_TEMPLATES_SET_TEMPLATE_STATUS_FILTERS:
        return {
          ...state,
          templates: {
            ...state.templates,
            templateStatusFilter: action.templateStatusFilter
          }
        };

      case REQUIREMENT_TEMPLATES_SET_TEMPLATE_CREATOR_FILTER:
        return {
          ...state,
          templates: {
            ...state.templates,
            creatorsFilter: action.creatorIds
          }
        };

      case REQUIREMENT_TEMPLATES_UPDATE_SEARCH_FILTER:
        return {
          ...state,
          templates: {
            ...state.templates,
            searchFilter: action.searchTerm
          }
        };

      case REQUIREMENT_TEMPLATES_SET_CURRENT_SORT:
        return {
          ...state,
          templates: {
            ...state.templates,
            sort: action.sort
          }
        };

      case REQUIREMENT_TEMPLATES_LIST_FOLDERS_SUCCESS: {
        const updatedData = action.pageInfo.currentPage > 1
          ? [...state.folders.data, ...action.data]
          : action.data;

        return {
          ...state,
          folders: {
            ...state.folders,
            data: updatedData,
            ...action.pageInfo
          }
        };
      }

      case REQUIREMENT_TEMPLATES_UPDATE_FOLDER_SUCCESS: {
        const updatedFolderData = modifyArrayItemAt(
          state.folders.data,
          'id',
          action.response.id,
          folder => ({ ...folder, name: action.response.name })
        );

        return {
          ...state,
          folders: {
            ...state.folders,
            data: updatedFolderData
          }
        };
      }

      case REQUIREMENT_TEMPLATES_DELETE_FOLDER_SUCCESS: {
        if (!action?.firstFolder) {
          return {
            ...state,
            folders: { ...initialState.folders },
            templates: { ...initialState.templates }
          };
        }

        return { ...state };
      }

      case REQUIREMENT_TEMPLATES_LIST_ARCHIVED_TEMPLATES:
      case REQUIREMENT_TEMPLATES_LIST_DRAFTED_TEMPLATES:
      case REQUIREMENT_TEMPLATES_LIST_TEMPLATES: {
        return {
          ...state,
          templatesLoading: action.pageData.pageNumber === 1
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_TEMPLATES_SUCCESS: {
        const updatedData = action.pageInfo.currentPage > 1
          ? [...state.templates.data, ...action.data]
          : action.data;

        return {
          ...state,
          templates: {
            ...state.templates,
            data: updatedData,
            ...action.pageInfo
          },
          templatesLoading: false
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_TEMPLATES_FAILURE: {
        return { ...state, templatesLoading: false };
      }

      case REQUIREMENT_TEMPLATES_GET_TEMPLATE_SUCCESS:
        return {
          ...state,
          selectedTemplate: action.response
        };

      case REQUIREMENT_TEMPLATES_UPDATE_TEMPLATE_SUCCESS:
        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            ...action.response
          }
        };

      case REQUIREMENT_TEMPLATES_DELETE_TEMPLATE: {
        const updatedData = removeArrayItemAt(state.templates.data, 'id', action.templateId);

        return {
          ...state,
          templates: {
            ...state.templates,
            data: updatedData
          }
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_BLOCK: {
        const updatedBlockOrder = state.selectedTemplate.requirementTemplateBlocks.map(block => {
          if (block.order >= action.data.order) {
            return { ...block, order: block.order + 1 };
          }

          return block;
        });

        const updatedTemplateBlocks = [
          ...updatedBlockOrder,
          { id: action.tempId, ...action.data }
        ].sort((a, b) => (a.order - b.order));

        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: updatedTemplateBlocks
          }
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_BLOCK_SUCCESS: {
        const updatedTemplateBlocks = modifyArrayItemAt(
          state.selectedTemplate.requirementTemplateBlocks,
          'id',
          action.tempId,
          () => (action.response)
        );

        return {
          ...state,
          changesPublishedStatus: Statuses.Success,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: updatedTemplateBlocks
          }
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_BLOCK_FAILURE: {
        return {
          ...state,
          changesPublishedStatus: Statuses.Error
        };
      }

      case REQUIREMENT_TEMPLATES_BULK_CREATE_TEMPLATE_BLOCKS_SUCCESS: {
        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: action.response
          }
        };
      }

      case REQUIREMENT_TEMPLATES_BULK_DELETE_AND_CREATE_REQUIREMENT_TEMPLATE_BLOCKS_SUCCESS: {
        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: action.response
          }
        };
      }

      case REQUIREMENT_TEMPLATES_UPDATE_BLOCK: {
        const { currentOrder, data, templateBlockId } = action;
        const newOrder = data.order;

        let sortedBlocks = state.selectedTemplate.requirementTemplateBlocks;

        if (currentOrder !== newOrder) {
          const minRange = Math.min(currentOrder, newOrder);
          const maxRange = Math.max(currentOrder, newOrder);

          const updatedBlocks = state.selectedTemplate.requirementTemplateBlocks.map(block => {
            if (block.id === templateBlockId) {
              return { ...block, ...data };
            }

            if ((block.order >= minRange) && (block.order <= maxRange)) {
              return { ...block, order: (currentOrder < newOrder) ? block.order - 1 : block.order + 1 };
            }

            return block;
          });
          sortedBlocks = updatedBlocks.sort((a, b) => (a.order - b.order));
        }

        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: sortedBlocks
          }
        };
      }

      case REQUIREMENT_TEMPLATES_UPDATE_BLOCK_SUCCESS: {
        const updatedTemplateBlocks = modifyArrayItemAt(
          state.selectedTemplate.requirementTemplateBlocks,
          'id',
          action.response.id,
          () => (action.response)
        );

        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: updatedTemplateBlocks
          }
        };
      }

      case REQUIREMENT_TEMPLATES_DELETE_BLOCK: {
        const updatedData = removeArrayItemAt(
          state.selectedTemplate.requirementTemplateBlocks,
          'id',
          action.templateBlockId
        );

        const updatedOrders = updatedData.map(block => {
          if (block.order >= action.order) {
            return { ...block, order: block.order - 1 };
          }

          return block;
        });

        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: updatedOrders
          }
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT: {
        const { tempId, question, blockIds } = action;
        const { selectedTemplate: { id: templateId, requirementTemplateBlocks } } = state;

        const updatedRequirementTemplateBlocks = requirementTemplateBlocks.map(block => {
          const blockHasQuestion = block.requirementTemplateQuestions.find(q => q.questionId === question.id);

          // if a block has the question id, but the block id is not included from the action, then remove the question object from that block
          if (blockHasQuestion && !blockIds.includes(block.id)) {
            return {
              ...block,
              requirementTemplateQuestions: block.requirementTemplateQuestions.filter(q => q.questionId !== question.id)
            };
          }

          // if a block has the question id, and the block id is included from the action, then return the block
          if (blockHasQuestion && blockIds.includes(block.id)) {
            return block;
          }

          // if a block does not have the question id, but the block id is included from the action, then add the question object to that block
          if (!blockHasQuestion && blockIds.includes(block.id)) {
            return {
              ...block,
              requirementTemplateQuestions: [
                ...block.requirementTemplateQuestions,
                {
                  id: tempId,
                  requirementTemplateId: templateId,
                  questionId: question.id,
                  order: null,
                  createdAt: null,
                  updatedAt: null,
                  pivot: {
                    requirementTemplateBlockId: block.id,
                    requirementTemplateQuestionId: tempId
                  },
                  question
                }
              ]
            };
          }

          // if a block does not have the question id, and the block id is not included from the action, then return the block
          return block;
        });

        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: updatedRequirementTemplateBlocks
          }
        };
      }

      case REQUIREMENT_TEMPLATES_UPDATE_QUESTION: {
        const { oldQuestionId, question } = action;
        const { selectedTemplate: { requirementTemplateBlocks } } = state;

        const updatedRequirementTemplateBlocks = requirementTemplateBlocks.map(block => {
          const updatedBlock = block.requirementTemplateQuestions.map(qB => {
            if (qB.questionId === oldQuestionId) {
              return { ...qB, question };
            }

            return qB;
          });

          return { ...block, requirementTemplateQuestions: updatedBlock };
        });

        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: updatedRequirementTemplateBlocks
          }
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT_SUCCESS: {
        const { selectedTemplate: { id: templateId, requirementTemplateBlocks } } = state;
        const { tempId, response } = action;

        const updatedRequirementTemplateBlocks = requirementTemplateBlocks.map(block => {
          const updatedRTQs = block.requirementTemplateQuestions.map(rTQ => {
            if (rTQ.id === tempId) {
              return {
                ...rTQ,
                id: response.id,
                pivot: {
                  ...rTQ.pivot,
                  requirementTemplateQuestionId: response.id
                }
              };
            }

            return rTQ;
          });

          return { ...block, requirementTemplateQuestions: updatedRTQs };
        });

        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: updatedRequirementTemplateBlocks
          }
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_QUESTION_REQUIREMENT_FAILURE:
        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: action.previousState
          }
        };

      case REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT: {
        const updatedRequirementTemplateBlocks = state.selectedTemplate.requirementTemplateBlocks.map(block => ({
          ...block,
          requirementTemplateQuestions: block.requirementTemplateQuestions.filter(q => q.questionId !== action.questionId)
        }));

        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: updatedRequirementTemplateBlocks
          }
        };
      }

      case REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_FAILURE:
        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: action.previousState
          }
        };

      case REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK: {
        const updatedRequirementTemplateBlocks = state.selectedTemplate.requirementTemplateBlocks.map(block => {
          if (block.id === action.templateBlockId) {
            return ({
              ...block,
              requirementTemplateQuestions: block.requirementTemplateQuestions.filter(q => q.pivot.requirementTemplateQuestionId !== action.requirementTemplateQuestionId)
            });
          }

          return block;
        });

        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: updatedRequirementTemplateBlocks
          }
        };
      }

      case REQUIREMENT_TEMPLATES_DELETE_QUESTION_REQUIREMENT_BLOCK_FAILURE:
        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            requirementTemplateBlocks: action.previousState
          }
        };

      case REQUIREMENT_TEMPLATES_SET_POLICY_TYPE_FILTERS:
        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            filters: action.filters
          }
        };

      case REQUIREMENT_TEMPLATES_UPDATE_POLICY_TYPE_SEARCH_FILTER:
        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            searchTerm: action.searchTerm
          }
        };

      case REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE: {
        const tempPolicy = {
          id: action.tempId,
          ...action.data
        };

        const updatedPolicyTypes = [tempPolicy, ...state.policyTypes.data];

        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            data: updatedPolicyTypes
          }
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_POLICY_TYPE_SUCCESS: {
        const updatedPolicyTypes = modifyArrayItemAt(
          state.policyTypes.data,
          'id',
          action.tempId,
          () => (action.response)
        );

        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            data: updatedPolicyTypes
          }
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_POLICY_TYPES_SUCCESS: {
        const updatedData = action.pageInfo.currentPage > 1
          ? [...state.policyTypes.data, ...action.data]
          : action.data;

        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            data: updatedData,
            ...action.pageInfo
          }
        };
      }

      case REQUIREMENT_TEMPLATES_DELETE_POLICY_TYPE: {
        const updatedData = removeArrayItemAt(
          state.policyTypes.data,
          'id',
          action.policyTypeId
        );

        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            data: updatedData
          }
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_DELETED_POLICY_TYPES_SUCCESS: {
        const updatedData = action.pageInfo.currentPage > 1
          ? [...state.policyTypes.deletedData, ...action.data]
          : action.data;

        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            deletedData: updatedData,
            deletedPageInfo: action.pageInfo
          }
        };
      }

      case REQUIREMENT_TEMPLATES_SET_DOCUMENT_TYPE_FILTERS:
        return {
          ...state,
          documentTypes: {
            ...state.documentTypes,
            filters: action.filters
          }
        };

      case REQUIREMENT_TEMPLATES_UPDATE_DOCUMENT_TYPE_SEARCH_FILTER:
        return {
          ...state,
          documentTypes: {
            ...state.documentTypes,
            searchTerm: action.searchTerm
          }
        };

      case REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE: {
        const tempDocument = {
          id: action.tempId,
          ...action.data
        };

        const updatedDocumentTypes = [tempDocument, ...state.documentTypes.data];

        return {
          ...state,
          documentTypes: {
            ...state.documentTypes,
            data: updatedDocumentTypes
          }
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_DOCUMENT_TYPE_SUCCESS: {
        const updatedDocumentTypes = modifyArrayItemAt(
          state.documentTypes.data,
          'id',
          action.tempId,
          () => (action.response)
        );

        return {
          ...state,
          documentTypes: {
            ...state.documentTypes,
            data: updatedDocumentTypes
          }
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_DOCUMENT_TYPES_SUCCESS: {
        const updatedData = action.pageInfo.currentPage > 1
          ? [...state.documentTypes.data, ...action.data]
          : action.data;

        return {
          ...state,
          documentTypes: {
            ...state.documentTypes,
            data: updatedData,
            ...action.pageInfo
          }
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_DELETED_DOCUMENT_TYPES_SUCCESS: {
        const updatedData = action.pageInfo.currentPage > 1
          ? [...state.documentTypes.deletedData, ...action.data]
          : action.data;

        return {
          ...state,
          documentTypes: {
            ...state.documentTypes,
            deletedData: updatedData,
            deletedPageInfo: action.pageInfo
          }
        };
      }

      case REQUIREMENT_TEMPLATES_DELETE_DOCUMENT_TYPE: {
        const updatedData = removeArrayItemAt(
          state.documentTypes.data,
          'id',
          action.documentTypeId
        );

        return {
          ...state,
          documentTypes: {
            ...state.documentTypes,
            data: updatedData
          }
        };
      }

      case REQUIREMENT_TEMPLATES_SET_LANGUAGE_FILTERS:
        return {
          ...state,
          languages: {
            ...state.languages,
            filters: action.filters
          }
        };

      case REQUIREMENT_TEMPLATES_UPDATE_LANGUAGE_SEARCH_FILTER:
        return {
          ...state,
          languages: {
            ...state.languages,
            searchTerm: action.searchTerm
          }
        };

      case REQUIREMENT_TEMPLATES_CREATE_LANGUAGE: {
        const tempLanguage = {
          id: action.tempId,
          ...action.data
        };

        const updatedLanguages = [tempLanguage, ...state.languages.data];

        return {
          ...state,
          languages: {
            ...state.languages,
            data: updatedLanguages
          }
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_LANGUAGE_SUCCESS: {
        const updatedLanguages = modifyArrayItemAt(
          state.languages.data,
          'id',
          action.tempId,
          () => (action.response)
        );

        return {
          ...state,
          languages: {
            ...state.languages,
            data: updatedLanguages
          }
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_LANGUAGES_SUCCESS: {
        const updatedData = action.pageInfo.currentPage > 1
          ? [...state.languages.data, ...action.data]
          : action.data;

        return {
          ...state,
          languages: {
            ...state.languages,
            data: updatedData,
            ...action.pageInfo
          }
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_DELETED_LANGUAGES_SUCCESS: {
        const updatedData = action?.pageInfo?.currentPage > 1
          ? [...state.languages.deletedData, ...action.data]
          : action.data;

        return {
          ...state,
          languages: {
            ...state.languages,
            deletedData: updatedData,
            deletedPageInfo: action.pageInfo
          }
        };
      }

      case REQUIREMENT_TEMPLATES_DELETE_LANGUAGE: {
        const updatedData = removeArrayItemAt(
          state.languages.data,
          'id',
          action.languageId
        );

        return {
          ...state,
          languages: {
            ...state.languages,
            data: updatedData
          }
        };
      }

      case REQUIREMENT_TEMPLATES_ADD_POLICY_TYPE_FAVORITE: {
        const updatedPolicyList = modifyArrayItemAt(
          state.policyTypes.data,
          'id',
          action.policyTypeId,
          policyType => ({ ...policyType, favorite: 1 })
        );

        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            data: updatedPolicyList
          }
        };
      }

      case REQUIREMENT_TEMPLATES_REMOVE_POLICY_TYPE_FAVORITE: {
        const updatedPolicyList = modifyArrayItemAt(
          state.policyTypes.data,
          'id',
          action.policyTypeId,
          policyType => ({ ...policyType, favorite: 0 })
        );

        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            data: updatedPolicyList
          }
        };
      }

      case REQUIREMENT_TEMPLATES_ADD_DOCUMENT_TYPE_FAVORITE: {
        const updatedDocumentList = modifyArrayItemAt(
          state.documentTypes.data,
          'id',
          action.documentTypeId,
          documentType => ({ ...documentType, favorite: 1 })
        );

        return {
          ...state,
          documentTypes: {
            ...state.documentTypes,
            data: updatedDocumentList
          }
        };
      }

      case REQUIREMENT_TEMPLATES_REMOVE_DOCUMENT_TYPE_FAVORITE: {
        const updatedDocumentList = modifyArrayItemAt(
          state.documentTypes.data,
          'id',
          action.documentTypeId,
          documentType => ({ ...documentType, favorite: 0 })
        );

        return {
          ...state,
          documentTypes: {
            ...state.documentTypes,
            data: updatedDocumentList
          }
        };
      }

      case REQUIREMENT_TEMPLATES_ADD_LANGUAGE_FAVORITE: {
        const updatedLanguageList = modifyArrayItemAt(
          state.languages.data,
          'id',
          action.languageId,
          language => ({ ...language, favorite: 1 })
        );

        return {
          ...state,
          languages: {
            ...state.languages,
            data: updatedLanguageList
          }
        };
      }

      case REQUIREMENT_TEMPLATES_REMOVE_LANGUAGE_FAVORITE: {
        const updatedLanguageList = modifyArrayItemAt(
          state.languages.data,
          'id',
          action.languageId,
          language => ({ ...language, favorite: 0 })
        );

        return {
          ...state,
          languages: {
            ...state.languages,
            data: updatedLanguageList
          }
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_TEMPLATE_SUCCESS: {
        return {
          ...state,
          selectedTemplate: {
            requirementTemplateBlocks: [],
            ...action.response
          }
        };
      }

      case REQUIREMENT_TEMPLATES_SET_CREATE_CUSTOM_STEP:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            createCustomStep: { [action.insuranceType]: action.step }
          }
        };

      case REQUIREMENT_TEMPLATES_SET_CURRENT_POLICY_PROPERTY_FIELD_TYPE:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            currentPolicyPropertyFieldType: action.propertyField,
            selectedPolicyPropertyFieldTypes: [
              ...state.displayOptions?.selectedPolicyPropertyFieldTypes ?? [],
              action.propertyField.id
            ]
          }
        };

      case REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_POLICY_TYPE:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            currentPolicyPropertyFieldOptions: initialState.displayOptions.currentPolicyPropertyFieldOptions,
            selectedPolicyPropertyFieldTypes: initialState.displayOptions.selectedPolicyPropertyFieldTypes,
            currentPolicyPropertyFieldType: initialState.displayOptions.currentPolicyPropertyFieldType,
            editCustomPolicyId: initialState.displayOptions.editCustomPolicyId
          }
        };

      case REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_DOCUMENT_TYPE:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            editCustomDocumentId: initialState.displayOptions.editCustomDocumentId
          }
        };

      case REQUIREMENT_TEMPLATES_RESET_CREATE_CUSTOM_LANGUAGE:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            editCustomLanguageId: initialState.displayOptions.editCustomLanguageId
          }
        };

      case REQUIREMENT_TEMPLATES_UPDATE_CURRENT_POLICY_INPUT_OPTIONS:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            currentPolicyPropertyFieldOptions: {
              ...state.displayOptions?.currentPolicyPropertyFieldOptions ?? {},
              [action.fieldType]: action.options
            }
          }
        };

      case REQUIREMENT_TEMPLATES_SETUP_EDIT_CUSTOM_POLICY_SUCCESS:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            currentPolicyPropertyFieldOptions: action.fieldProperties,
            selectedPolicyPropertyFieldTypes: action.fieldTypes
          }
        };

      case REQUIREMENT_TEMPLATES_DELETE_CURRENT_POLICY_INPUT_OPTION: {
        const updatedOptionsData = removeArrayItemAtIndex(
          state.displayOptions.currentPolicyPropertyFieldOptions[action.fieldType],
          action.optionIndex
        );

        if (updatedOptionsData.length) {
          return {
            ...state,
            displayOptions: {
              ...state.displayOptions,
              currentPolicyPropertyFieldOptions: {
                ...state.displayOptions?.currentPolicyPropertyFieldOptions,
                [action.fieldType]: updatedOptionsData
              }
            }
          };
        }

        const updatedSelectedData = state.displayOptions.selectedPolicyPropertyFieldTypes
          .filter(field => field !== action.fieldType);
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            selectedPolicyPropertyFieldTypes: updatedSelectedData,
            currentPolicyPropertyFieldOptions: {
              ...state.displayOptions?.currentPolicyPropertyFieldOptions,
              [action.fieldType]: updatedOptionsData
            }
          }
        };
      }

      case REQUIREMENT_TEMPLATES_RESET_SELECTED_TEMPLATE: {
        return {
          ...state,
          selectedTemplate: null
        };
      }

      case REQUIREMENT_TEMPLATES_CREATE_FOLDER_SUCCESS: {
        return {
          ...state,
          folders: {
            ...state.folders,
            currentFolder: action.response.id
          }
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES: {
        return {
          ...state,
          allPublishedTemplates: {
            ...state.allPublishedTemplates,
            isLoading: true
          }
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_ALL_PUBLISHED_TEMPLATES_SUCCESS: {
        return {
          ...state,
          allPublishedTemplates: {
            ...state.allPublishedTemplates,
            data: action.data,
            ...action.pageInfo,
            isLoading: false
          }
        };
      }

      case REQUIREMENT_TEMPLATES_UPDATE_PUBLISHED_LIST_SORT: {
        return {
          ...state,
          allPublishedTemplates: {
            ...state.allPublishedTemplates,
            sort: action.sort
          }
        };
      }

      case REQUIREMENT_TEMPLATES_SET_PUBLISHED_CREATOR_FILTER: {
        return {
          ...state,
          allPublishedTemplates: {
            ...state.allPublishedTemplates,
            creatorsFilter: action.creatorIds
          }
        };
      }

      case REQUIREMENT_TEMPLATES_UPDATE_PUBLISHED_SEARCH_FILTER: {
        return {
          ...state,
          allPublishedTemplates: {
            ...state.allPublishedTemplates,
            searchFilter: action.searchTerm
          }
        };
      }

      case REQUIREMENT_TEMPLATES_SET_CURRENT_TEMPLATE_BLOCK:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            currentRequirementTemplateBlockId: action.blockId
          }
        };

      case REQUIREMENT_TEMPLATES_SET_CURRENT_EDIT_TEMPLATE:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            currentEditTemplateId: action.templateId
          }
        };

      case REQUIREMENT_TEMPLATES_RESET_CURRENT_TEMPLATE_BLOCK: {
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            currentRequirementTemplateBlockId: null
          }
        };
      }

      case REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_POLICY_ID:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            editCustomPolicyId: action.customPolicyId
          }
        };
      case REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_DOCUMENT_ID:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            editCustomDocumentId: action.customDocumentId
          }
        };
      case REQUIREMENT_TEMPLATES_SET_EDIT_CUSTOM_LANGUAGE_ID:
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            editCustomLanguageId: action.customLanguageId
          }
        };

      case REQUIREMENT_TEMPLATES_RESET_FILTERS: {
        const { requirementType } = action;
        return {
          ...state,
          [requirementType]: {
            ...state[requirementType],
            filters: {
              customs: true,
              defaults: true
            }
          }
        };
      }

      case REQUIREMENT_TEMPLATES_SET_STAGED_FOLDER: {
        return {
          ...state,
          selectedTemplate: {
            ...state.selectedTemplate,
            stagedFolder: action.folder
          }
        };
      }

      case REQUIREMENT_TEMPLATES_SET_CURRENT_INSURED_ID: {
        return {
          ...state,
          insuredId: action.insuredId
        };
      }

      case REQUIREMENT_TEMPLATES_SET_CURRENT_JOB_ID: {
        return {
          ...state,
          jobId: action.jobId
        };
      }

      case REQUIREMENT_TEMPLATES_SET_BACK_BUTTON_TEXT: {
        return {
          ...state,
          backButtonOptions: {
            ...state.backButtonOptions,
            text: action.text
          }
        };
      }

      case REQUIREMENT_TEMPLATES_LIST_FOLDER_TEMPLATES: {
        return {
          ...state,
          templatesLoading: true
        };
      }

      case REQUIREMENT_TEMPLATES_SET_UPDATING_REQUIREMENTS: {
        return {
          ...state,
          displayOptions: {
            ...state.displayOptions,
            updatingRequirements: action.isUpdating
          }
        };
      }

      case REQUIREMENT_TEMPLATES_UPDATE_OR_CREATE_INSURED_REQUIREMENT_TEMPLATE_SUCCESS: {
        return {
          ...state,
          selectedTemplate: action.response
        };
      }

      case REQUIREMENT_TEMPLATES_RESET_ALL: {
        return { ...initialState };
      }

      case REQUIREMENT_TEMPLATES_RESET_CURRENT_FOLDER: {
        return {
          ...state,
          folders: {
            ...state.folders,
            currentFolder: null
          },
          templates: {
            ...state.templates,
            folderFilter: null
          }
        };
      }

      case REQUIREMENT_TEMPLATES_SET_PUBLISHING_STATUS: {
        return {
          ...state,
          changesPublishedStatus: action.status
        };
      }

      case REQUIREMENT_TEMPLATES_SET_CURRENT_POLICY_TYPE: {
        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            currentPolicyType: action.policyType
          }
        };
      }

      case REQUIREMENT_TEMPLATES_RESET_CURRENT_POLICY_TYPE: {
        return {
          ...state,
          policyTypes: {
            ...state.policyTypes,
            currentPolicyType: null
          }
        };
      }

      default:
        return state;
    }
  };

  const reducer = requirementTemplateReducer;

  /* Selectors
  ========================================================= */
  const selectRequirementTemplateFolders = state => state[name].folders;
  const selectRequirementTemplates = state => state[name].templates;
  const selectCurrentRequirementTemplate = state => state[name].selectedTemplate;
  const selectCurrentRequirementTemplateBlocks = state => state[name].selectedTemplate?.requirementTemplateBlocks;
  const selectCurrentRequirementTemplateBlock = state => state[name].selectedTemplate?.requirementTemplateBlocks
    .filter(block => block.id === state[name].displayOptions.currentRequirementTemplateBlockId);
  const selectInsurancePolicyTypes = state => state[name].policyTypes;
  const selectInsurancePolicyTypeFilters = state => state[name].policyTypes.filters;
  const selectInsuranceDocumentTypes = state => state[name].documentTypes;
  const selectInsuranceLanguages = state => state[name].languages;
  const selectDefaultTemplateTabIdLeft = state => state
    [name].displayOptions.defaultTemplateTabIdLeft;
  const selectDefaultTemplateTabIdRight = state => state
    [name].displayOptions.defaultTemplateTabIdRight;
  const selectCreateCustomStep = type => state => state[name].displayOptions.createCustomStep[type];
  const selectCurrentCustomPolicyPropertyFieldType = state => state
    [name].displayOptions.currentPolicyPropertyFieldType;
  const selectSelectedPolicyPropertyFieldTypes = state => state[name]
    .displayOptions.selectedPolicyPropertyFieldTypes;
  const selectCurrentEditCustomPolicyId = state => state
    [name].displayOptions.editCustomPolicyId;
  const selectCurrentEditCustomDocumentId = state => state
    [name].displayOptions.editCustomDocumentId;
  const selectCurrentEditCustomLanguageId = state => state
    [name].displayOptions.editCustomLanguageId;
  const selectCurrentPolicyPropertyFieldOptions = state => state
    [name].displayOptions.currentPolicyPropertyFieldOptions;
  const selectCurrentEditTemplateId = state => state
    [name].displayOptions.currentEditTemplateId;
  const selectPublishedRequirementTemplates = state => state[name].allPublishedTemplates;
  const selectTemplatesLoading = state => state[name].templatesLoading;
  const selectAllPublishedTemplatesLoading = state => state[name].allPublishedTemplates.isLoading;
  const selectLeftTabTypeOption = state => state[name].leftTabTypeOption;
  const selectRightTabTypeOption = state => state[name].rightTabTypeOption;
  const selectCurrentInsuredId = state => state[name].insuredId;
  const selectCurrentJobId = state => state[name].jobId || state[name].selectedTemplate?.jobId;
  const selectBackButtonOptions = state => state[name].backButtonOptions;
  const selectSaveButtonOptions = state => state[name].saveButtonOptions;
  const selectShowSideHeaders = state => state[name].showSideHeaders;
  const selectBuilderHeight = state => state[name].builderHeight;
  const selectSidePanelHeight = state => state[name].sidePanelHeight;
  const selectUpdatingRequirements = state => state[name].updatingRequirements;
  const selectDropdownTemplateId = state => state[name].dropDownTemplateId;
  const selectTemplateById = id => state => state[name].templates?.data?.find(t => t.id === id);
  const selectChangesPublishedStatus = state => state[name].changesPublishedStatus;
  const selectPolicyTypeById = id => state => [...state[name].policyTypes.data, ...state[name].policyTypes.deletedData].find(p => p.id === id);

  const selectCurrentPolicyType = state => state[name].policyTypes.currentPolicyType;

  const selectBlueprintName = state => state[name].blueprintName;

  return {
    reducer,
    selectBlueprintName,
    selectCurrentInsuredId,
    selectCurrentJobId,
    selectRightTabTypeOption,
    selectLeftTabTypeOption,
    selectRequirementTemplateFolders,
    selectRequirementTemplates,
    selectCurrentRequirementTemplate,
    selectCurrentRequirementTemplateBlocks,
    selectCurrentRequirementTemplateBlock,
    selectInsurancePolicyTypes,
    selectInsurancePolicyTypeFilters,
    selectInsuranceDocumentTypes,
    selectInsuranceLanguages,
    selectDefaultTemplateTabIdLeft,
    selectDefaultTemplateTabIdRight,
    selectCreateCustomStep,
    selectCurrentCustomPolicyPropertyFieldType,
    selectSelectedPolicyPropertyFieldTypes,
    selectCurrentEditCustomPolicyId,
    selectCurrentEditCustomDocumentId,
    selectCurrentEditCustomLanguageId,
    selectCurrentPolicyPropertyFieldOptions,
    selectCurrentEditTemplateId,
    selectPublishedRequirementTemplates,
    selectTemplatesLoading,
    selectAllPublishedTemplatesLoading,
    setCurrentRequirementTemplateFolder,
    setCurrentRequirementTemplateStatusFilters,
    setCurrentRequirementTemplateCreatorFilter,
    setCurrentRequirementTemplateSearchFilter,
    setCurrentRequirementTemplateSort,
    createRequirementTemplateFolder,
    listRequirementTemplateFolders,
    updateRequirementTemplateFolder,
    deleteRequirementTemplateFolder,
    createRequirementTemplate,
    listRequirementTemplates,
    listFolderRequirementTemplates,
    listArchivedRequirementTemplates,
    listDraftedRequirementTemplates,
    getRequirementTemplate,
    updateRequirementTemplate,
    deleteRequirementTemplate,
    bulkCreateRequirementTemplateBlocks,
    createRequirementTemplateBlock,
    updateRequirementTemplateBlock,
    updateInsurancePolicyType,
    updateInsuranceDocumentType,
    updateInsuranceLanguage,
    deleteRequirementTemplateBlock,
    setInsurancePolicyTypeFilters,
    updateInsurancePolicyTypeSearchFilter,
    createInsurancePolicyType,
    listInsurancePolicyTypes,
    listDefaultInsurancePolicyTypes,
    listCustomInsurancePolicyTypes,
    deleteInsurancePolicyType,
    setInsuranceDocumentTypeFilters,
    updateInsuranceDocumentTypeSearchFilter,
    createInsuranceDocumentType,
    listInsuranceDocumentTypes,
    listDeletedDocumentTypes,
    listDefaultInsuranceDocumentTypes,
    listCustomInsuranceDocumentTypes,
    deleteInsuranceDocumentType,
    setInsuranceLanguageFilters,
    updateInsuranceLanguageSearchFilter,
    createInsuranceLanguage,
    listInsuranceLanguages,
    listDefaultInsuranceLanguages,
    listCustomInsuranceLanguages,
    listDeletedInsuranceLanguages,
    deleteInsuranceLanguage,
    addPolicyTypeFavorite,
    removePolicyTypeFavorite,
    addDocumentTypeFavorite,
    removeDocumentTypeFavorite,
    addLanguageFavorite,
    removeLanguageFavorite,
    setCreateCustomStep,
    setCurrentPolicyPropertyFieldType,
    setEditCustomPolicyId,
    setEditCustomDocumentId,
    setEditCustomLanguageId,
    resetCreateCustomPolicyType,
    resetCreateCustomDocumentType,
    resetCreateCustomLanguage,
    updateCurrentPropertyInputOptions,
    deleteCurrentPropertyInputOption,
    resetSelectedTemplate,
    listAllPublishedTemplates,
    updatePublishedListSort,
    setPublishedTemplatesCreatorFilter,
    updatePublishedTemplateSearchFilter,
    setCurrentRequirementTemplateBlock,
    setCurrentEditTemplateId,
    resetCurrentRequirementTemplateBlock,
    setupEditCustomPolicyType,
    resetFilters,
    setStagedFolder,
    setCurrentInsuredId,
    setCurrentJobId,
    setBackButtonText,
    selectBackButtonOptions,
    selectSaveButtonOptions,
    selectShowSideHeaders,
    bulkDeleteAndCreateRequirementTemplateBlocks,
    selectBuilderHeight,
    listDeletedPolicyTypes,
    setUpdatingRequirements,
    selectUpdatingRequirements,
    resetRequirementTemplateState,
    selectTemplateById,
    selectDropdownTemplateId,
    setDropdownTemplateId,
    resetDropdownTemplateId,
    updateOrCreateInsuredRequirementTemplate,
    selectSidePanelHeight,
    resetCurrentFolder,
    selectChangesPublishedStatus,
    updateChangesPublishedStatus,
    selectPolicyTypeById,
    selectCurrentPolicyType,
    setCurrentPolicyType,
    resetCurrentPolicyType,
    deleteEmptyBlocks,
    createQuestionRequirement,
    updateQuestion,
    deleteQuestionRequirement,
    deleteQuestionRequirementBlock
  };

  /* Utils
  ================================================== */
  function getFilters(requirementTypeFilters) {
    let filters;
    if (requirementTypeFilters.customs && requirementTypeFilters.defaults) {
      filters = {};
    } else if (!requirementTypeFilters.customs && !requirementTypeFilters.defaults) {
      filters = requirementTypeFilters;
    } else {
      const checkedFilter = Object.keys(requirementTypeFilters).filter(key => requirementTypeFilters[key] !== false);
      filters = { [checkedFilter]: true };
    }

    return filters;
  }
};
